import { useTranslations } from "use-intl";
import { Attachments, AttachmentsProps } from "./attachment/attachment";
import ImgCrop, { ImgCropProps } from "antd-img-crop";

type UploadWithCropProps = {
  cropProps?: Omit<ImgCropProps, "children">;
} & AttachmentsProps;

export function UploadWithCrop(props: UploadWithCropProps) {
  const t = useTranslations("Common");
  const { cropProps, ...attachProps } = props;
  return (
    <ImgCrop
      cropShape="round"
      modalTitle={t("Crop image")}
      modalOk={t("Save")}
      modalCancel={t("Cancel")}
      modalClassName="[&.img-crop-modal]:z-[2000]"
      {...cropProps}
    >
      <Attachments showUploadList={false} maxCount={1} {...attachProps} />
    </ImgCrop>
  );
}
